import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AnexoAvanceProcesalResponseDto } from '../dto/anexo/anexo.dto';

@Injectable({
  providedIn: 'root',
})
export class AnexoService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/anexo';

  constructor(private http: HttpClient) {}

  getAnexosByAvanceProcesalId(
    avanceProcesalId: number
  ): Observable<AnexoAvanceProcesalResponseDto[]> {
    return this.http.get<AnexoAvanceProcesalResponseDto[]>(
      `${this.apiUrl}${this.baseUrl}/avance-procesal/${avanceProcesalId}`
    );
  }

  descargarAnexo(nombre: string): Observable<Blob> {
    return this.http.get(
      `${this.apiUrl}${this.baseUrl}/descarga?nombre=${nombre}`,
      {
        responseType: 'blob',
      }
    );
  }
}
